/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskZoomInfoFunding } from './ExecRiskZoomInfoFunding';
import {
    ExecRiskZoomInfoFundingFromJSON,
    ExecRiskZoomInfoFundingFromJSONTyped,
    ExecRiskZoomInfoFundingToJSON,
} from './ExecRiskZoomInfoFunding';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedZoomInfoFundingResponse
 */
export interface ExecRiskPaginatedZoomInfoFundingResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoFundingResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskZoomInfoFunding>}
     * @memberof ExecRiskPaginatedZoomInfoFundingResponse
     */
    results: Array<ExecRiskZoomInfoFunding>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedZoomInfoFundingResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoFundingResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoFundingResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedZoomInfoFundingResponse interface.
 */
export function instanceOfExecRiskPaginatedZoomInfoFundingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedZoomInfoFundingResponseFromJSON(json: any): ExecRiskPaginatedZoomInfoFundingResponse {
    return ExecRiskPaginatedZoomInfoFundingResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedZoomInfoFundingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedZoomInfoFundingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskZoomInfoFundingFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedZoomInfoFundingResponseToJSON(value?: ExecRiskPaginatedZoomInfoFundingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskZoomInfoFundingToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

